/**
 * Controls the state of the media info tabs on the details page
 * @param {string} tab The tab to open
 */
window.infoTab = function(tab) {
    var descElem = $('.js-title-description-container');
    var creatorsElem = $('.js-title-creators');
    var creatorsTab = $('.js-creators-tab');
    var detailsElem = $('.js-format-details');
    var descTab = $('.js-description-tab');
    var detailsTab = $('.js-details-tab');
    var reviewsTab = $('.js-reviews-tab');
    var reviewsElem = $('.js-reviews');

    if (tab === 'description') {
        // Hide details/creators and show desc
        detailsElem.css('display', 'none');
        detailsTab.removeClass('is-active');
        detailsTab.children('a').attr('aria-label', window.html('titleDetails.details'));

        creatorsElem.css('display', 'none');
        creatorsTab.removeClass('is-active');
        creatorsTab.children('a').attr('aria-label', window.html('titleDetails.creators'));

        reviewsElem.css('display', 'none');
        reviewsTab.removeClass('is-active');
        reviewsTab.children('a').attr('aria-label', window.html('titleDetails.reviews'));

        descElem.css('display', 'block');
        descTab.addClass('is-active');
        descTab.children('a').attr('aria-label', window.html('titleDetails.descriptionActive'));

    } else if (tab === 'format-details') {
        // Hide desc/creators and show details
        detailsElem.css('display', 'block');
        detailsTab.addClass('is-active');
        detailsTab.children('a').attr('aria-label', window.html('titleDetails.detailsActive'));

        creatorsElem.css('display', 'none');
        creatorsTab.removeClass('is-active');
        creatorsTab.children('a').attr('aria-label', window.html('titleDetails.creators'));

        reviewsElem.css('display', 'none');
        reviewsTab.removeClass('is-active');
        reviewsTab.children('a').attr('aria-label', window.html('titleDetails.reviews'));

        descElem.css('display', 'none');
        descTab.removeClass('is-active');
        descTab.children('a').attr('aria-label', window.html('titleDetails.description'));

    } else if (tab === 'creators') {
        // Hide desc/details and show details
        detailsElem.css('display', 'none');
        detailsTab.removeClass('is-active');
        detailsTab.children('a').attr('aria-label', window.html('titleDetails.details'));

        descElem.css('display', 'none');
        descTab.removeClass('is-active');
        descTab.children('a').attr('aria-label', window.html('titleDetails.description'));

        reviewsElem.css('display', 'none');
        reviewsTab.removeClass('is-active');
        reviewsTab.children('a').attr('aria-label', window.html('titleDetails.reviews'));

        creatorsElem.css('display', 'block');
        creatorsTab.addClass('is-active');
        creatorsTab.children('a').attr('aria-label', window.html('titleDetails.creatorsActive'));

    } else if (tab === 'reviews') {
        // Hide desc/details and show details
        detailsElem.css('display', 'none');
        detailsTab.removeClass('is-active');
        detailsTab.children('a').attr('aria-label', window.html('titleDetails.details'));

        descElem.css('display', 'none');
        descTab.removeClass('is-active');
        descTab.children('a').attr('aria-label', window.html('titleDetails.description'));

        creatorsElem.css('display', 'none');
        creatorsTab.removeClass('is-active');
        creatorsTab.children('a').attr('aria-label', window.html('titleDetails.creators'));

        reviewsElem.css('display', 'block');
        reviewsTab.addClass('is-active');
        reviewsTab.children('a').attr('aria-label', window.html('titleDetails.reviewsActive'));

        // Hide read more link if the review is short
        $('[class*="js-reviewContent-"]:visible').each(function() {
            if ($(this)[0].scrollHeight <= $(this).height()) {
                $('.is-desktop.js-readMoreContainer-' + $(this).attr('data-review')).hide();
            }
        });
    }
}

var descElem = $('.js-title-description');

// Hide arrow and fade if text is too short to require it.
window.onload = function () {
    var titleDescVisible = $('.js-title-description:visible');
    if (titleDescVisible.length) {
        if (titleDescVisible[0].scrollHeight <= (titleDescVisible.height() + 5)) {
            $('.js-description-arrow').hide();
            $('.js-title-description').removeClass('is-short');
        } else {
            $('hr.more').show();
        }
    }
};


$('body').on('click', '.js-description-arrow.is-unexpanded', function() {
    $(this).removeClass('is-unexpanded').addClass('is-expanded');
    $(this).attr('src', window.OverDrive.cdn + '/public/img/less.png');
    $(this).attr('alt', window.html('titleDetails.collapseDescriptionLabel'));
    descElem.removeClass('is-short').addClass('is-long');
});

$('body').on('click', '.js-description-arrow.is-expanded', function() {
    $(this).removeClass('is-expanded').addClass('is-unexpanded');
    $(this).attr('src', window.OverDrive.cdn + '/public/img/more.png');
    $(this).attr('alt', window.html('titleDetails.expandDescriptionLabel'));
    descElem.removeClass('is-long').addClass('is-short');
});

// Change focus between tabs with arrow keys
$('.TitleDetailsDescription-infoTabLink').on('keydown', function(e) {
    // define current, previous and next (possible) tabs

    var $original = $(this);
    var $prev = $(this).parents('li').prev().children('.TitleDetailsDescription-infoTabLink');
    var $next = $(this).parents('li').next().children('.TitleDetailsDescription-infoTabLink');

    if ($next.length == 0) {
        $next = $(this).closest('ul').children('li:first-child').children('.TitleDetailsDescription-infoTabLink');
    }

    if ($prev.length == 0) {
        $prev = $(this).closest('ul').children('li:last-child').children('.TitleDetailsDescription-infoTabLink');
    }

    var $target = '';

    // find the direction (prev or next)
    switch (e.keyCode) {
        case 37:
            $target = $prev;
            break;
        case 38:
            $target = $prev;
            break;
        case 39:
            $target = $next;
            break;
        case 40:
            $target = $next;
            break;
        default:
            $target = false;
            break;
    }

    if ($target.length) {
        $original.attr({
            'tabindex' : '-1'
        });

        setTimeout(function() {
            $target.attr({
                'tabindex' : '0'
            }).focus().click();
        }, 0);
    }
});

// added for screen-readers targeting the heading on closed tabs
$('.TitleDetailsDescription-infoTabLink').on('focus', function(e) {
    e.currentTarget.click();
});

// Clicking wishlist icon should click link for sign in
$('.icon-wish-list').on('click', function() {
    $(this).siblings('a:first')[0].click();
});

/**
 * Set the Disney EULA cookie
 */
$('#disney-eula-accept').on('click', function(){
    Cookies.set('disney-eula-setting', '1');
    $('#submit-borrow').removeAttr('data-reveal-id').attr('href', $(this).attr('href')).attr('target', '_blank');
    $('#disney-eula-modal').foundation('reveal', 'close');
});

$('#sample-modal').on('opened.fndtn.reveal', function() {
    var iframe = $('#sample-iframe');
    var sampleLink = iframe.attr('data-src');
    iframe.attr('src', sampleLink);
});
